import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

export const RouterUnstyledLink = styled(Link)`
  text-decoration: inherit;
  color: inherit;
  cursor: inherit;
`
